import VideoBanner from '@/components/banners/VideoBanner';
import { ModuleVideoBannerFragment } from '@/graphql';
import { getSingle } from '@/lib/typescript-helpers';
import { extractYouTubeId } from '@/lib/youtube';
import { FC } from 'react';

interface VideoBannerModuleProps {
  props: CraftModuleFragment<ModuleVideoBannerFragment>;
}

const VideoBannerModule: FC<VideoBannerModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props || !props.youtubeVideoUrl) return null;

  const videoId = extractYouTubeId(props.youtubeVideoUrl);
  const image = getSingle(props.coverImage);

  if (!videoId || !image) return null;

  return (
    <VideoBanner
      heading={props.heading ?? ''}
      youtubeVideoId={videoId}
      coverImage={{
        src: image.url!,
        height: image.height!,
        width: image.width!,
      }}
      buttonText={props.buttonText ?? undefined}
    />
  );
};

export default VideoBannerModule;
